// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"165":"57dfeeead529fb43","773":"1bd6ae8389f30e93","890":"0c83e2b6435bcf51","938":"3aead4ebe65ea3f4"}[chunkId] + ".js";
};